<template>
  <button
    type="button"
    class="BaseSwitch relative h-6 w-11 inline-flex flex-shrink-0 items-center rounded-full transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2"
    :class="{
      'bg-dark focus:ring-dark': value,
      'bg-gray-300 focus:ring-gray-400': !value,
      'cursor-not-allowed opacity-50': disabled
    }"
    :disabled="disabled"
    @click="handleToggle"
  >
    <span
      class="inline-block h-4 w-4 transform rounded-full bg-white transition duration-200 ease-in-out"
      :class="{
        'translate-x-6': value,
        'translate-x-1': !value
      }"
    />
  </button>
</template>

<script>
export default {
  name: 'BaseSwitch',

  props: {
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    handleToggle() {
      if (this.disabled) return

      this.$emit('input', !this.value)
    }
  }
}
</script>

<style scoped lang="scss">
.BaseSwitch {
  &:focus {
    @apply ring-offset-2;
  }
}
</style>
